<template>
  <tr>
    <td
      class="text-center align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <span class="form-control form-control-plaintext">{{
        rowIndex + 1
      }}</span>
    </td>
    <td 
      v-if="item.isPreviousBalance == true"
      class="form-group text-center align-middle"
    >
      {{ item.documentNumber }}
    </td>
    <td
      class="form-group text-center align-middle"
      v-else-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <input
        :id="'documentNumber_' + rowIndex"
        :name="'documentNumber_' + rowIndex"
        type="text"
        class="form-control required"
        placeholder="เลขที่เอกสาร"
        :readonly="!isEditable"
        v-model="item.documentNumber"
        data-msg-required="กรุณากรอกเลขที่เอกสาร"
        @blur="onDocumentNumberBlur(false)"
      />
      <span class="form-text"></span>
    </td>
    <td
      v-if="showHeader"
      class="form-group text-center align-middle"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      {{ item.documentDate }}
    </td>
    <td
      class="form-group align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      {{ item.soldTo }}
      {{ item.soldToName }}
      <template v-if="item.shipToName && item.soldToName != item.shipToName"
        >({{ item.shipToName }})</template
      >
    </td>
    <template v-if="item.items.length > 0">
      <td class="align-middle">
        {{ item.items[itemIndex].materialCode }}
        {{ item.items[itemIndex].materialName }}
      </td>
      <td class="text-right align-middle" v-if="item.items[itemIndex].reCalQuantity != null && item.items[itemIndex].reCalQuantity > 0">
        {{ item.items[itemIndex].quantity }}
        ( {{ item.items[itemIndex].reCalQuantity }} )
      </td>
      <td class="text-right align-middle" v-else>
        {{ item.items[itemIndex].quantity }}
      </td>
      <td class="text-right align-middle">
        {{ item.items[itemIndex].salesUnit }}
      </td>
    </template>
    <template v-else>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
    </template>
    <td
      v-if="showHeader && item.isPreviousBalance == false"
      class="text-center align-middle"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <button
        v-if="isEditable && jobType != 'RETRIEVE_ITEM'"
        type="button"
        class="btn btn-outline-hover-info btn-elevate btn-circle btn-icon"
        title="โหลดใหม่"
        @click.prevent="onDocumentNumberBlur(true)"
      >
        <i class="text-info la la-refresh"></i>
      </button>

      <button
        v-if="isEditable && jobType != 'RETRIEVE_ITEM'"
        type="button"
        class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
        title="ลบรายการ"
        @click.prevent="onRemoveItemClick"
      >
        <i class="text-danger la la-trash"></i>
      </button>
    </td>
    <td v-else></td>
  </tr>
</template>

<script>
import axios from "axios";

export default {
  props: {
    isEditable: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    apiUrl: {
      type: String,
      default: "/Api/Sml/Invoice",
    },
    rowIndex: Number,
    itemIndex: Number,
    showHeader: {
      type: Boolean,
      default: true,
    },
    rootItems: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    jobType: {
      type: String,
    },
    agentCode: {
      type: String,
    },
  },
  data() {
    return {
      oldDocumentNumber: null,
    };
  },
  methods: {
    onDocumentNumberBlur(force = false) {
      let self = this;

      var hasDocNumber =
        $.grep(self.rootItems, function(obj, i) {
          return (
            i != self.rowIndex && obj.documentNumber == self.item.documentNumber
          );
        }).length > 0;

      if (hasDocNumber) {
        Swal.fire("เกิดข้อผิดพลาด", "คุณกรอกเลขที่ใบส่งสินค้าซ้ำ", "warning");
        return false;
      }

      if (
        self.item.documentNumber &&
        (force || self.oldDocumentNumber != self.item.documentNumber)
      ) {
        self.oldDocumentNumber = self.item.documentNumber;

        axios
          .get(
            self.apiUrl +
              "/" +
              encodeURIComponent(self.item.documentNumber) +
              "?agentCode=" +
              self.agentCode
          )
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data;
              self.item.id = data.id;
              self.item.documentNumber = data.documentNumber;
              self.item.documentDate = data.documentDate;
              self.item.refDocNumber = data.refDocNumber;
              self.item.shipTo = data.shipTo;
              self.item.shipToName = data.shipToName;
              self.item.soldTo = data.soldTo;
              self.item.soldToName = data.soldToName;
              self.item.items = data.items;

              self.$parent.onCalculateItemClick();
            } else {
              self.item.id = null;
              self.item.documentDate = null;
              self.item.items = [];

              if (self.apiUrl == "/Api/Sml/Invoice") {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  "ไม่พบข้อมูลบิลขาย (Invoice) " +
                    self.item.documentNumber +
                    "<br />กรุณาตรวจสอบข้อมูลในระบบ SML ทั้งนี้ท่านจะต้องสร้างใบเบิกสินค้าโดยอ้างอิงเลขที่เอกสารของบิลขายก่อนจึงจะสามารถใช้งานได้",
                  "warning"
                );
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  "ไม่พบข้อมูลเอกสาร " +
                    self.item.documentNumber +
                    "<br />กรุณาตรวจสอบข้อมูลในระบบ SML",
                  "warning"
                );
              }
            }
          })
          .catch(function(error) {
            self.item.id = null;
            self.item.documentDate = null;
            self.item.items = [];
            console.log(error.response);

            if (!self.agentCode) {
              Swal.fire(
                "เกิดข้อผิดพลาด",
                'กรุณาเลือกตัวแทนฯในช่อง "สถานที่ต้นทาง (Origin)" ก่อน',
                "error"
              );
            } else {
              Swal.fire(
                "เกิดข้อผิดพลาด",
                error.response.data && error.response.data.message
                  ? error.response.data.message
                  : "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลใบส่งสินค้าได้ในขณะนี้",
                "error"
              );
            }
          });
      } else {
        self.item.id = null;
        self.item.documentDate = null;
        self.item.items = [];
      }
    },
    onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    },
  },
  mounted() {
    $(".required", this.$el).each(function() {
      const $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required"),
        },
      });
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Job/JobRefInvoiceRow.vue